import { Button, Col, Row, Table, Tag } from 'antd'
import React, { useState } from 'react'
import { ValidTableModel } from '../../../../../models/valid-table.model';
import i18n from "../../../../../utils/i18n"
import { EllipseIcon } from '../../../../atoms/icon';
import "./valid-table.scss"

const columns = [
    {
        title: <Button className='yellow-contained' >{i18n.t("FundsTransferPricing.validUntil")}
            <span className='valid-date'>  05/31/2024</span>
        </Button>,
        dataIndex: 'validUntil',
        key: 'validUntil',
        width: 240,
        align: 'right' as const,
        render: (text: string) => {
            return <div className='column-with-line' >
                <div>
                    {text}
                </div>
                <div className='line' ></div>
            </div>
        }
    },
    {
        title: i18n.t("FundsTransferPricing.fptCurve"),
        dataIndex: 'fptCurve',
        key: 'fptCurve',
        align: 'center' as const,
        render: (text: string, record: ValidTableModel, rowIndex: number) => {
            return <div className={rowIndex === 0 ? 'underline' : 'row-item'} >
                {record.validUntil === "Status" ? <Tag className='ok-tag' icon={<EllipseIcon className='ellipse' />} >
                    OK
                </Tag> : text}

            </div>
        }
    },
    {
        title: i18n.t("FundsTransferPricing.businessCycle"),
        dataIndex: 'businessCycle',
        key: 'businessCycle',
        align: 'center' as const,
        render: (text: string, record: ValidTableModel, rowIndex: number) => {
            return <div className={rowIndex === 0 ? 'underline' : 'row-item'} >
                {record.validUntil === "Status" ? <Tag className='ok-tag' icon={<EllipseIcon className='ellipse' />} >
                    OK
                </Tag> : text}
            </div>
        }

    },
    {
        title: i18n.t("FundsTransferPricing.riskParameters"),
        dataIndex: 'riskParameters',
        key: 'riskParameters',
        align: 'center' as const,
        width: "max-content",
        render: (text: string[], record: ValidTableModel, rowIndex: number) => {
            return <div className='parameters' >
                {text.map((item, i) => {
                    return <div key={i} className={`param-item ${rowIndex === 0 ? 'underline' : 'row-item'}`}>
                        {record.validUntil === "Status" ? <Tag className='ok-tag' icon={<EllipseIcon className='ellipse' />} >
                            OK
                        </Tag> : item}

                    </div>
                })}
            </div>
        }
    }
];

const ValidTable = () => {
    const [data, setData] = useState<ValidTableModel[]>([
        {
            id: 1,
            validUntil: "Section",
            fptCurve: "Market",
            businessCycle: "Scenarios",
            riskParameters: ["PD", "EAD", "LGD"]
        },
        {
            id: 2,
            validUntil: "Update Interval",
            fptCurve: "Weekly",
            businessCycle: "Monthly",
            riskParameters: ["Monthly", "Monthly", "Monthly"]
        },
        {
            id: 3,
            validUntil: "Updated",
            fptCurve: "05/31/2024",
            businessCycle: "05/31/2024",
            riskParameters: ["05/31/2024", "05/31/2024", "05/31/2024"]
        },
        {
            id: 4,
            validUntil: "Status",
            fptCurve: "OK",
            businessCycle: "OK",
            riskParameters: ["OK", "OK", "OK"]
        },
    ]);

    return (
        <div className='valid-table-wrapper' >
            <Row>
                <Col span={24}>
                    <Table
                        loading={false}
                        dataSource={data}
                        pagination={false}
                        columns={columns} rowKey="id" />
                </Col>
            </Row>
        </div>
    )
}

export default ValidTable